<template>
    <div>
        <div class="container" v-if="step < 4">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div class="steps">
                        <progress class="step-progress" :value="progress" max="100"></progress>
                        <div class="step-item">
                            <div
                                class="step-button text-center"
                                :class="{current: step === 1, done: step >= 1}"
                            ></div>
                        </div>
                        <div class="step-item">
                            <div
                                class="step-button text-center"
                                :class="{current: step === 2, done: step >= 2}"
                            ></div>
                        </div>
                        <div class="step-item">
                            <div
                                class="step-button text-center"
                                :class="{current: step === 3, done: step >= 3}"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <form ref="step1" v-if="step === 1">
                        <h2 class="subtitle">Proprietário</h2>
                        <div class="row">
                            <div class="col-12">
                                <input
                                    type="text"
                                    name="name"
                                    data-msg-required="Por favor informe seu nome."
                                    required
                                    placeholder="Nome *"
                                    v-model="form.name"
                                >
                            </div>
                            <div class="col-12 col-md-6">
                                <the-mask
                                    type="tel"
                                    name="phone"
                                    placeholder="Celular *"
                                    :mask="['(##) ####-####', '(##) #####-####']"
                                    v-model="form.phone"
                                    masked
                                    required
                                />
                            </div>
                            <div class="col-12 col-md-6">
                                <the-mask
                                    type="tel"
                                    name="phone2"
                                    placeholder="Telefone"
                                    :mask="['(##) ####-####', '(##) #####-####']"
                                    v-model="form.phone2"
                                    masked
                                    required
                                ></the-mask>
                            </div>
                            <div class="col-12">
                                <input
                                    type="email"
                                    name="email"
                                    required
                                    placeholder="Email *"
                                    v-model="form.email"
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 btn">
                                <button
                                    type="button"
                                    class="img-button btn-padrao"
                                    @click="saveOwner"
                                    :disabled="processing"
                                >
                                    <i v-if="processing" class="fa-solid fa-circle-notch fa-spin"></i>
                                    <i v-else class="fa-solid fa-arrow-right"></i>
                                    Próximo
                                </button>
                            </div>
                        </div>
                    </form>

                    <form ref="step2" v-if="step === 2">
                        <h2 class="subtitle">Características</h2>
                        <div class="row">
                            <div class="col-12">
                                <select
                                    name="type"
                                    v-model="form.type"
                                >
                                    <option value="">Tipo</option>
                                    <option
                                        v-for="(type, i) of types" :key="`type-${i}`"
                                        :value="type._id"
                                        v-text="type.text"
                                    ></option>
                                </select>
                            </div>
                            <div class="col-6">
                                <label>
                                    <input type="checkbox" v-model="forSale" class="mb-2">
                                    Para venda
                                </label>

                                <currency-input
                                    v-if="forSale"
                                    name="salePrice"
                                    v-model="form.salePrice"
                                    required
                                    placeholder="Valor para venda"
                                ></currency-input>
                            </div>
                            <div class="col-6">
                                <label>
                                    <input type="checkbox" v-model="forRent" class="mb-2">
                                    Para locação
                                </label>

                                <currency-input
                                    v-if="forRent"
                                    name="rentPrice"
                                    v-model="form.rentPrice"
                                    required
                                    placeholder="Valor para locação"
                                ></currency-input>
                            </div>
                            <div class="col-12">
                                <input
                                    type="text"
                                    name="complexName"
                                    placeholder="Nome do condomínio / ediifício"
                                    v-model="form.complexName"
                                >
                            </div>
                            <div class="col-12">
                                <currency-input
                                    name="complexFee"
                                    v-model="form.complexFee"
                                    placeholder="Valor do condomínio"
                                ></currency-input>
                            </div>
                            <div class="col-12">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="acceptFinancing"
                                        v-model="form.acceptFinancing"
                                        class="mb-2"
                                    >
                                    Aceita financiamento?
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 col-md-4">
                                <the-mask
                                    v-model="form.address.postcode"
                                    type="tel"
                                    name="postcode"
                                    placeholder="CEP"
                                    mask="#####-###"
                                    masked
                                    required
                                ></the-mask>
                            </div>
                            <div class="col-12">
                                <input
                                    type="text"
                                    name="street"
                                    placeholder="Endereço"
                                    v-model="form.address.street"
                                    required
                                >
                            </div>
                            <div class="col-6 col-md-4">
                                <input
                                    type="text"
                                    name="number"
                                    placeholder="Número"
                                    v-model="form.address.number"
                                >
                            </div>
                            <div class="col-6 col-md-8">
                                <input
                                    type="text"
                                    name="complement"
                                    placeholder="Complemento"
                                    v-model="form.address.complement"
                                >
                            </div>
                            <div class="col-12 col-md-6">
                                <input
                                    type="text"
                                    name="area"
                                    placeholder="Bairro"
                                    v-model="form.address.area"
                                >
                            </div>
                            <div class="col-12 col-md-6">
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="Cidade"
                                    v-model="form.address.city"
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="areaTotal"
                                    placeholder="Área total / terreno"
                                    v-model="form.areaTotal"
                                >
                            </div>
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="areaUtil"
                                    placeholder="Área útil / contruída"
                                    v-model="form.areaUtil"
                                >
                            </div>
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="bedrooms"
                                    placeholder="Dormitórios"
                                    v-model="form.bedrooms"
                                >
                            </div>
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="suites"
                                    placeholder="Suítes"
                                    v-model="form.suites"
                                >
                            </div>
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="bathrooms"
                                    placeholder="Banheiros"
                                    v-model="form.bathrooms"
                                >
                            </div>
                            <div class="col-6">
                                <input
                                    type="number"
                                    name="garages"
                                    placeholder="Vagas de garagem"
                                    v-model="form.garages"
                                >
                            </div>
                            <div class="col-12">
                                <textarea
                                    name="notes"
                                    placeholder="Outras características (pense nos diferenciais que seu imóvel possui)"
                                    v-model="form.notes"
                                ></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 btn">
                                <button
                                    type="button"
                                    class="img-button btn-padrao"
                                    @click="saveCaracteristics"
                                    :disabled="processing"
                                >
                                    <i v-if="processing" class="fa-solid fa-circle-notch fa-spin"></i>
                                    <i v-else class="fa-solid fa-arrow-right"></i>
                                    Próximo
                                </button>
                            </div>
                        </div>
                    </form>

                    <form ref="step3" v-if="step === 3">
                        <div class="row">
                            <div class="col-6">
                                <h2 class="subtitle">Fotos</h2>
                            </div>
                            <div class="col-6">
                                <label
                                    v-if="!processing"
                                    class="img-button btn-padrao float-end"
                                >
                                    <input
                                        type="file"
                                        id="photo"
                                        accept="image/*"
                                        multiple
                                        @change="addPhoto"
                                        style="display: none;"
                                    >
                                    <i class="fa-solid fa-plus"></i>
                                    Selecionar fotos
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div
                                        v-for="(photo, index) in form.images"
                                        :key="`card-${index}`"
                                        class="col-6 col-lg-4 mb-3"
                                    >
                                        <div class="card">
                                            <img
                                                :src="photo.url"
                                                class="card-img-top img-fluid"
                                                :alt="photo.fileName"
                                            >
                                            <progress
                                                v-if="photo.processing"
                                                class="progress"
                                                :value="photo.progress"
                                                max="100"
                                            ></progress>
                                            <div class="btn-image-close">
                                                <button
                                                    v-if="!photo.processing"
                                                    type="button"
                                                    class="btn"
                                                    @click="removePhoto(index)"
                                                >
                                                    <i class="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 btn">
                                <button
                                    v-if="form.images.length > 0"
                                    type="button"
                                    class="img-button btn-padrao"
                                    @click="startUpload"
                                    :disabled="processing"
                                >
                                    <i v-if="processing" class="fa-solid fa-circle-notch fa-spin"></i>
                                    <i v-else class="fa-solid fa-cloud-arrow-up"></i>
                                    Enviar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="subtitle">Obrigado! Seu imóvel foi cadastrado com sucesso.</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CurrencyInput from "./CurrencyInput.vue";

export default {
    name: "PropertyRegister",
    components: {CurrencyInput},
    props: {
        action: {
            type: String,
            required: true
        },
        csrf: {
            type: String,
            required: true
        },
        types: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            form: {
                id: null,
                name: null,
                email: null,
                phone: null,
                phone2: null,
                use: null,
                type: '',
                salePrice: null,
                rentPrice: null,
                complexName: null,
                complexFee: null,
                acceptFinancing: null,
                address: {
                    postcode: null,
                    state: null,
                    city: null,
                    street: null,
                    area: null,
                    number: null,
                    complement: null,
                },
                details: {
                    areaTotal: null,
                    areaUtil: null,
                    bedrooms: null,
                    suites: null,
                    bathrooms: null,
                    garages: null,
                },
                notes: null,
                images: [],
            },
            step: 1,
            processing: false,
            forSale: false,
            forRent: false,
        }
    },
    computed: {
        progress() {
            return ((this.step - 1) * 100) / 2;
        }
    },
    watch: {
        async 'form.address.postcode'(value) {
            if (value.length === 9) {
                const address = await axios
                    .get(`https://viacep.com.br/ws/${value}/json/`)
                    .then(response => response.data);
                this.form.address.state = address['uf'];
                this.form.address.city = address['localidade'];
                this.form.address.street = address['logradouro'];
                this.form.address.area = address['bairro'];
            }
        },
    },
    methods: {
        async saveOwner() {
            if (!this.$refs.step1.checkValidity()) {
                this.$refs.step1.reportValidity();
                return;
            }

            this.processing = true;

            const register = await axios
                .post(this.action, this.form, {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf,
                    },
                })
                .then(response => response.data)
                .finally(() => this.processing = false);

            if (register.id) {
                this.form.id = register.id;
                this.step = 2;
                return;
            }

            this.$refs.step1.reportValidity();
            alert('Ocorreu um erro ao salvar os dados.');
        },
        async saveCaracteristics() {
            if (!this.$refs.step2.checkValidity()) {
                this.$refs.step2.reportValidity();
                return;
            }

            this.processing = true;

            const register = await axios
                .put(this.action + '/' + this.form.id, this.form, {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf,
                    },
                })
                .then(response => response.data)
                .finally(() => this.processing = false);

            if (register.id) {
                this.step = 3;
                return;
            }

            this.$refs.step1.reportValidity();
            alert('Ocorreu um erro ao salvar os dados.');
        },
        addPhoto(event) {
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (!file.type.match('image.*')) {
                    continue;
                }

                const reader = new FileReader();
                reader.onload = (event) => {
                    this.form.images.push({
                        url: event.target.result,
                        file: file,
                        fileName: file.name,
                        info: {
                            size: file.size,
                            type: file.type,
                        },
                        processing: false,
                        progress: 0,
                        uploaded: false,
                    });
                };
                reader.readAsDataURL(file);
            }
        },
        removePhoto(index) {
            this.form.images.splice(index, 1);
        },
        startUpload() {
            //count files uploading
            let uploading = this.form.images.filter(image => image.processing && !image.uploaded).length;

            //max 5 files at once
            let files = this.form.images
                .filter(image => !image.processing && !image.uploaded)
                .slice(0, 5 - uploading);

            files.forEach(file => {
                file.processing = true;
                this.uploadFile(file);
            });
        },
        uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file.file, file.fileName);
            formData.append('info', JSON.stringify(file.info));

            file.processing = true;

            axios
                .post(this.action + '/' + this.form.id + '/upload', formData, {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf,
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (event) => {
                        file.progress = Math.round((event.loaded * 100) / event.total);
                    },
                })
                .then(() => {
                    file.uploaded = true;

                    this.checkUpload();
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    file.processing = false;
                });
        },
        checkUpload() {
            const uploaded = this.form.images.filter(photo => photo.uploaded);
            if (uploaded.length === this.form.images.length) {
                this.step = 4;
            }

            this.startUpload();
        },
    },
};
</script>

<style scoped>
.steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
}
.step-button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background-color: #d4d4d4;
    transition: .4s;
}
.step-button.current {
    width: 60px;
    height: 60px;
    background-color: var(--primary-color);
    color: #fff;
}
.step-button.done {
    background-color: var(--primary-color);
    color: #fff;
}
.step-item {
    z-index: 10;
    text-align: center;
}
.step-progress {
    -webkit-appearance:none;
    position: absolute;
    width: 95%;
    z-index: 5;
    height: 10px;
    margin-left: 18px;
}
/* to customize progress bar */
.step-progress::-webkit-progress-value {
    background-color: var(--primary-color);
    transition: .5s ease;
}
.step-progress::-webkit-progress-bar {
    background-color: #d4d4d4;
}
.card-img-top {
    object-position: center center;
    width: 100%;
    aspect-ratio: 4/3;
    -o-object-fit: cover;
    object-fit: cover;
}
.progress {
    -webkit-appearance: none;
    width: 90%;
    z-index: 5;
    height: 10px;
    margin-left: 5%;
    margin-top: 10px;
    position: absolute;
    bottom: 5px;
}
/* to customize progress bar */
.progress::-webkit-progress-value {
    background-color: var(--primary-color);
}
.progress::-webkit-progress-bar {
    background-color: #d4d4d4;
}
.btn-image-close {
    position: absolute;
    top: 0;
    right: 0;
}
</style>
